export enum TwilioConversationState {
  inactive = 'inactive',
  active = 'active',
  closed = 'closed',
}

export type TwilioConversationStateType = keyof typeof TwilioConversationState;
